import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
    transform(value: any, args: string[]): any {
        let excludeEmptyProperties: boolean = args && args.indexOf('excludeEmptyProperties') >= 0;
        let keys: any[] = [];
        for (let key in value) {
            if (key != 'ID' && (!excludeEmptyProperties || value[key]))
                keys.push({ key: key, value: value[key] });
        }
        return keys;
    }
}